import { useEffect } from "react";

import { useDi } from "~/entities/di";
import { useConfig } from "~/shared/config";
import { SLASH } from "~/shared/str";

function useGoogleAds() {
  const {
    google: { googleConversionTagId, googleConversionLabels },
  } = useConfig();
  const { eventBus } = useDi();

  useEffect(() => {
    const handler: Parameters<typeof eventBus.on<"customerCreatedOrder">>[1] = ({ id }) => {
      window.gtag("event", "conversion", {
        send_to: [googleConversionTagId, googleConversionLabels.ORDER_CREATION].join(SLASH),
        transaction_id: id,
      });
    };

    const params = ["customerCreatedOrder", handler] as const;
    eventBus.on(...params);

    return () => {
      eventBus.off(...params);
    };
  }, [eventBus, googleConversionLabels.ORDER_CREATION, googleConversionTagId]);
}

export { useGoogleAds };
